import { Icon, PathButton } from "shared/react";

export function ChallengeDialog({ id }: { id: string }): React.ReactElement {
	return (
		<article>
			<h1>Well done {id}</h1>
			<PathButton path="/posts/new">
				<Icon icon="photo" /> <span>Post victory photo</span>
			</PathButton>
		</article>
	);
}
